"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var DashboardComplaints = function DashboardComplaints(props) {
  return _react2.default.createElement(_SvgIcon2.default, (0, _extends3.default)({ viewBox: "0 0 100 125", className: "custom-icon" }, props), _react2.default.createElement("path", { d: "M50.6585106,58.4585106 C48.5218085,58.4585106 46.7585106,60.2010638 46.7585106,62.3585106 C46.7585106,64.4952128 48.5010638,66.2585106 50.6585106,66.2585106 C52.7952128,66.2585106 54.5585106,64.5159574 54.5585106,62.3585106 C54.5585106,60.2010638 52.8159574,58.4585106 50.6585106,58.4585106 Z", id: "Shape" }), _react2.default.createElement("path", { d: "M31.2207447,42.9 C31.2207447,40.7632979 29.4781915,39 27.3207447,39 C25.1840426,39 23.4207447,40.7425532 23.4207447,42.9 C23.4207447,45.0367021 25.1632979,46.8 27.3207447,46.8 C29.4781915,46.7792553 31.2207447,45.0367021 31.2207447,42.9 Z", id: "Shape" }), _react2.default.createElement("path", { d: "M62.337766,23.4414894 L62.337766,7.88297872 L66.2170213,7.88297872 L66.2170213,0.103723404 L50.6585106,0.103723404 L50.6585106,7.88297872 L54.5585106,7.88297872 L54.5585106,15.662234 L39,0.103723404 L0.103723404,39 L7.88297872,39 L7.88297872,77.8962766 L70.1170213,77.8962766 L70.1170213,39 L77.8962766,39 L62.337766,23.4414894 Z M19.5414894,42.9 C19.5414894,38.6058511 23.0265957,35.1207447 27.3207447,35.1207447 C31.6148936,35.1207447 35.1,38.6058511 35.1,42.9 C35.1,47.1941489 31.6148936,50.6792553 27.3207447,50.6792553 C23.0265957,50.6792553 19.5414894,47.1941489 19.5414894,42.9 Z M25.5781915,70.1170213 L46.8207447,35.1 L52.4218085,35.1 L31.137766,70.1170213 L25.5781915,70.1170213 Z M50.6585106,70.1170213 C46.3643617,70.1170213 42.8792553,66.6319149 42.8792553,62.337766 C42.8792553,58.043617 46.3643617,54.5585106 50.6585106,54.5585106 C54.9526596,54.5585106 58.437766,58.043617 58.437766,62.337766 C58.437766,66.6319149 54.9734043,70.1170213 50.6585106,70.1170213 Z", id: "Shape" }));
};

exports.default = DashboardComplaints;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/dashboard-complaint.js
// module id = ../lib/egov-ui-kit/custom-icons/dashboard-complaint.js
// module chunks = 504